const editVideoDataConstantsAr = {
  inventoryManagementNavBar: 'إدارة الوسائط المتعددة',
  editVideoDataPageTitle: 'تعديل معلومات الفيديو',
  editVideoDataSaveButton: 'حفظ المعلومات',
  editVideoDataVideoTitleEn: 'عنوان الفيديو (الإنجليزية)',
  editVideoDataVideoTitleAr: 'عنوان الفيديو (العربية)',
  editVideoDataVideoDescriptionEn: 'وصف الفيديو (الإنجليزية)',
  editVideoDataVideoDescriptionAr: 'وصف الفيديو (العربية)',
  editVideoDataManageTagsText: 'إدارة بيانات الفيديو',
  editVideoDataEnglishGenreLabel: 'النوع (الإنجليزية)',
  editVideoDataArabicGenreLabel: 'النوع (العربية)',
  editVideoDataDurationLabel: 'مدة العرض',
  editVideoDataLocationLabel: 'الموقع',
  editVideoDataQualityLabel: 'جودة الفيديو',
  editVideoDataYearLabel: 'سنة النشر',
  editVideoDataPriceLabel: 'السعر',
  editVideoDataVideoDurationHours: 'ساعات',
  editVideoDataVideoDurationMinutes: 'دقائق',
  editVideoDataVideoDurationSeconds: 'ثواني',
  editVideoDataVideoVideoTitleEmptyError: 'عنوان الفيديو مطلوب',
  editVideoDataVideoVideoSubtitleError: 'العنوان الفرعي للفيديو مطلوب',
  editVideoDataVideoVideoDescriptionError: 'وصف الفيديو مطلوب',
  editVideoDataVideoGenreError: 'الأنواع مطلوب',
  editVideoDataVideoCastError: 'الأدوار مطلوبة',
  editVideoDataVideoTagError: 'العلامات مطلوبة',
  editVideoDataVideoFormatsError: 'التنسيقات مطلوبة',
  editVideoDataVideoAvailabilityError: 'التوفر مطلوب',
  editVideoDataVideoIsRestrictedError: 'محدود / غير محدود مطلوب',
  editVideoDataVideoIsRushError: 'فوري / غير فوري مطلوب',
  editVideoDataVideoLanguageError: 'اللغة مطلوبة',
  editVideoDataVideoDurationError: 'المدة مطلوبة',
  editVideoDataVideoQualityError: 'جودة الفيديو مطلوبة',
  editVideoDataVideoYearError: 'سنة النشر مطلوبة',
  editVideoDataVideoPriceError: 'السعر مطلوب',
  editVideoDataDeleteChipDialogTitle: 'حذف',
  editVideoDataDeleteTagDialogContent: 'هل أنت متأكد أنك تريد حذف',
  editVideoDataEditBtn: 'تعديل',
  editVideoDataDeleteBtn: 'حذف',
  editVideoDataAddBtn: 'إضافة',
  editVideoDataUpdateBtn: 'تحديث',
  editVideoDataCancelBtn: 'إلغاء',
  editVideoDataAddNewGenreBtn: 'إضافة نوع جديد',
  editVideoDataAddNewTagBtn: 'إضافة علامة جديدة',
  editVideoDataAddNewCastBtn: 'إضافة اشخاص جدد',
  editVideoDataGenresLabel: 'الأنواع',
  editVideoDataTagsLabel: 'الكلمات الدلالية',
  editVideoDataCastLabel: 'الشخصيات',
  editVideoDataAddNewRowBtn: 'إضافة سعر جديد',
  editVideoDataFormatsLabel: 'الصيغة',
  editVideoDataAvailabilityLabel: 'التوفر',
  editVideoDataIsRestrictedLabel: 'محظور',
  editVideoDataIsRushLabel: 'كامل / مقطع',
  editVideoDataRush: 'مقطع',
  editVideoDataNonRush: 'كامل',
  editVideoDataLanguageLabel: 'اللغة',
  addChipDialogGenresTitle: 'إضافة نوع جديد',
  addChipDialogCastTitle: 'إضافة أدوار جديدة',
  addChipDialogTagsTitle: 'إضافة علامة جديدة',
  addChipDialogEnglishChipLabel: 'الإنجليزية',
  addChipDialogArabicChipLabel: 'العربية',
  addChipDialogAddButton: 'إضافة',
  editVideoDataExclusive: 'حصري',
  editVideoDataNonExclusive: 'غير حصري',
  editVideoDataRestricted: 'محظور',
  editVideoDataNotRestricted: 'غير محظور',
  editVideoDataLanguageArabic: 'العربية',
  editVideoDataLanguageEnglish: 'الإنجليزية',
  editVideoDataLanguageBilingual: 'العربية والإنجليزية',
  addChipDialogEnglishChipRequired: 'العلامة الإنجليزية مطلوبة',
  addChipDialogArabicChipRequired: 'العلامة العربية مطلوبة',
  editVideoDataChipAlreadyExist: 'العلامة موجودة بالفعل',
  editVideoDataReferenceId: 'الرقم المرجعي',
  editVideoDataBrightcoveId: 'الرقم في المخزون',
  editVideoDataCategoryLabel: 'الفئات',
  editVideoDataCountryLabel: 'البلدان',
  addChipDialogCountryTitle: 'إضافة بلد جديد',
  addChipDialogCategoreyTitle: 'إضافة فئة جديدة',
  editVideoDataVideoCategoryError: 'الفئات مطلوبة',
  editVideoDataVideoCountryError: 'البلدان مطلوبة',
  durationLicense: 'مدة الرخصة',
  annual: 'سنوي',
  unlimited: 'غير محدود',
  editVideoDataVideoRushDurationPriceError: 'سعر مقاطع الفيديو السريعة حسب مدة الترخيص سنوي/غير محدود مطلوب',
  demographicTitle: 'الديموقرافية',
  editVideoDataVideoDemographicError: 'الديموقرافية مطلوبة',
  editVideoDataVideoLicenseError: 'مدة الترخيص مطلوبة',
  updateDetails: 'تعديل معلومات الفيديو',
  quality: 'الجودة',
  annualPrice: 'السعر لمدة سنة',
  unlimitedPrice: 'السعر لمدة غير محدودة',
  actions: 'الإجراءات',
  key: 'المفتاح',
  value: 'القيمة',
  editVideoDataVideoRushDemographicError: 'الديموقرافية مطلوبة',
  editVideoDataVideoTagsError: 'الوسوم مطلوبة',
  editVideoDataVideoLocationError: 'الموقع مطلوب',
  editVideoDataVideoLanguageTypeError: 'اللغة مطلوبة',
  riyal_symbol: 'ر.س',
  addChipDialogCategoryTitle: 'إضافة فئة جديدة',
  addChipDialogDemographicTitle: 'إضافة ديموقرافية جديدة',
  priceIsRequired: 'السعر مطلوب',
  thisFieldIsRequired: 'هذا الحقل مطلوب',

  deleteVideoButton: 'حذف المادة',
  deleteMediaDialogTitle: 'تأكيد الحذف',
  deleteMediaDialogDescriptionP1: 'أنت على وشك حذف هذه المادة من سيما. يرجى العلم أن هذا الإجراء لا يمكن التراجع عنه.',
  deleteMediaDialogDescriptionP2: ' سيؤثر حذف هذه المادة على عدة أماكن، بما في ذلك قائمة المفضلات، السلة و طلبات عروض الأسعار.',
  deleteMediaDialogDescriptionP3: 'قد يؤدي هذا الإجراء إلى إزالة أو تغيير المعلومات ذات الصلة في الأماكن المذكورة أعلاه.',
  deleteMediaDialogConfirmationQuestion: 'هل أنت متأكد من أنك تريد المتابعة في عملية الحذف؟',
  deleteMediaDialogCancelButton: 'لا',
  deleteMediaDialogConfirmButton: 'تأكيد الحذف',
  mediaDeletedSuccessfully: 'تم الحذف بنجاح',
  editVideoDataVideoReferenceIdField: 'الرقم المرجعي مطلوب',
  editVideoDataVideoBrightcoveIdField: 'الرقم في المخزون مطلوب',
  editVideoDataVideoFileTypeField: 'نوع الملف مطلوب',
  editVideoDataOwnerLabel: 'المالك',
};

export default editVideoDataConstantsAr;
